import { Item } from './Item';
import { Root } from './Root';

export const Collapsible = {
  Root,
  Item
};
